/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React from 'react';

function EmptyScreen({ title }) {
    return (
        <>
            {/* <div>
                <h5 className="text-xs4 font-semibold text-[#555259]">Trade & Commercial Policy/Offer</h5>
            </div> */}
            <div className="w-full flex flex-col justify-center items-center" style={{ height: '80vh', overflow: 'auto' }}>
                <img src="/images/Group8022.svg" alt="icon" />
                <p className="text-lg font-bold text-[#15090E] mt-2">{title || 'It seems you haven\'t added an offer yet!'}</p>
                {title === undefined && (
                    <a href="/manage-offers/create-new-offer">
                        <button
                            type="button"
                            className="w-[290px] h-[52px] bg-[#555259] rounded-lg text-lg font-semibold text-[#FFFFFF] text-center mt-[30px]"
                        >
                            Create Offer
                        </button>
                    </a>
                )}
            </div>
        </>

    );
}

export default EmptyScreen;
